import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectEditScene = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectEditScene,
  }))
);

export const customObjectEditNRO: NavigationRoutingObject = {
  Component: CustomObjectEditScene,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Account Edit",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Store business records and connect them to your users"),
  icon: "nav-system-accounts",
  tag: "early-access",
  // Deliberately feature-flipper-only, like the sibling custom objects NROs. The
  // `editCustomObjects` check lives in the scene (`CustomObjectEditScene`), which renders
  // `LimitedAccess` — gating here instead would redirect the developer to `/` with no explanation.
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("accounts_nro_component") && featureOn("b2b_ea");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
